module.exports = __webpack_public_path__ + "img/cmcc.7c6eba94.png";